<template>
  <div>
    <v-row
      align="stretch"
      class="my-2"
      no-gutters
      :key="groupIndex"
      v-for="(group, groupIndex) in groupedInteractions"
    >
      <!-- Usuario Info Desktop -->
      <v-col
        cols="2"
        :order="isMyInteraction(group[0].user) ? 'first' : 'last'"
        :class="isMyInteraction(group[0].user) ? 'text-left' : 'text-right'"
        v-if="!$vuetify.breakpoint.mobile"
      >
        <div class="pa-2 user-container-info">
          <div class="d-flex flex-column justify-space-between">
            <div :class="isMyInteraction(group[0].user) ? 'justify-start' : 'justify-end'">
              <div class="d-flex align-center">
                <div style="width: 100%;">
                  <div class="d-flex flex-column text-center align-center">
                    <img
                      :src="resolveUser(group[0].user).info.avatar"
                      class="inner-user-avatar"
                      v-if="resolveUser(group[0].user).info.avatar"
                    />
                    <v-icon v-else class="inner-user-avatar icon" color="#2D4B95" size="40">
                      mdi-account-circle
                    </v-icon>
                    <div class="mt-1" style="width: 100%;">
                      <p
                        class="mb-0 text--disabled caption"
                        style="line-height: 10px;"
                        v-if="resolveUser(group[0].user).projectjob && resolveUser(group[0].user).projectjob.userjobtype"
                      >
                        {{ resolveUser(group[0].user).projectjob.userjobtype.name }}
                      </p>
                      <p
                        class="mb-0 text-primary font-weight-bold caption"
                      >
                        {{ resolveUser(group[0].user).name }}
                      </p>
                    </div>

          <GlobalFileViewer
            :document-item="viewerDocumentItem"
            :forge-item="viewerForgeItem"
            @close="closeViewers"
            @minimize-file="minimizeViewerFile"
            @open-morphable="openAssociatedItem"
            @error="onViewerError"
            @load="onViewerLoad"
          />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>

      <!-- Usuario Info Mobile (posicionado al inicio) -->
      <v-col
        cols="12"
        v-if="$vuetify.breakpoint.mobile"
        class="user-info-mobile mb-2"
        :class="{ 'justify-start': isMyInteraction(group[0].user), 'justify-end': !isMyInteraction(group[0].user) }"
      >
        <div 
          class="d-flex align-center" 
          style="gap: 4px;"
          :class="{ 'flex-row-reverse': !isMyInteraction(group[0].user) }"
        >
          <div class="pa-2 user-container-info user-info-mobile-container">
            <div class="d-flex align-center" style="gap: 8px;">
              <img
                :src="resolveUser(group[0].user).info.avatar"
                class="inner-user-avatar"
                v-if="resolveUser(group[0].user).info.avatar"
              />
              <v-icon v-else class="inner-user-avatar icon" color="#2D4B95" size="32">
                mdi-account-circle
              </v-icon>
              <div>
                <p
                  class="mb-0 text--disabled caption"
                  style="line-height: 10px;"
                  v-if="resolveUser(group[0].user).projectjob && resolveUser(group[0].user).projectjob.userjobtype"
                >
                  {{ resolveUser(group[0].user).projectjob.userjobtype.name }}
                </p>
                <p
                  class="mb-0 text-primary font-weight-bold caption"
                >
                  {{ resolveUser(group[0].user).name }}
                </p>
              </div>
            </div>
          </div>
          <v-icon color="#2D4B95" size="18" style="flex-shrink: 0;">mdi-chevron-down</v-icon>
        </div>
      </v-col>

      <v-col cols="12" sm="10">
        <div class="messages-group" :class="{ 'single-message': group.length === 1 }">
          <div
            v-for="(interaction, messageIndex) in group"
            :key="messageIndex"
            class="interaction-container"
            :class="setClassInteraction(interaction)"
            :data-interaction-id="interaction.id"
            :ref="`interaction-${interaction.id}`"
          >
            <div class="interaction-message-container py-2 px-3">
              <v-icon
                v-if="!$vuetify.breakpoint.mobile"
                :color="interaction.is_response ? '#CAE7CC' : '#E5E9F2'"
                class="icon-arrow"
              >
                {{ isMyInteraction(interaction.user) ? 'mdi-menu-left' : 'mdi-menu-right' }}
              </v-icon>
              <p class="mb-0 text-primary font-weight-bold" v-if="interaction.is_response">
                Respuesta Oficial
              </p>

              <!-- Referencia a interacción padre -->
              <div
                v-if="interaction.parent_interaction"
                class="parent-interaction-reference"
              >
                <div class="d-flex align-center" style="gap: 6px;">
                  <v-icon size="12" color="#5E85EF" style="flex-shrink: 0;">mdi-reply</v-icon>
                  <button
                    class="parent-link-btn"
                    @click="scrollToInteraction(interaction.parent_interaction.id)"
                    :title="`Ir a respuesta de ${resolveUser(interaction.parent_interaction.user).name}`"
                  >
                    <span class="text-xs text--secondary" style="line-height: 1.2;">
                      Respuesta a
                      <span class="font-weight-bold text-primary">
                        {{ resolveUser(interaction.parent_interaction.user).name }}
                      </span>
                    </span>
                  </button>
                  <img
                    v-if="resolveUser(interaction.parent_interaction.user).info.avatar"
                    :src="resolveUser(interaction.parent_interaction.user).info.avatar"
                    class="parent-avatar"
                    style="flex-shrink: 0;"
                  />
                  <v-icon v-else size="12" color="#5E85EF" style="flex-shrink: 0;">mdi-account-circle</v-icon>
                </div>
              </div>

              <div class="my-0">
                <div
									style="font-size: 13px;"
                  v-html="$options.filters.highligthSearch(interaction.message || interaction.description, searchText)"
                ></div>
								<MediaGallery :items="interaction.attachments" />
              </div>
							<!-- Subinteracciones anidadas (interactions[]) -->
							<div
								v-if="interaction.interactions && interaction.interactions.length > 0"
								class="sub-interactions mt-2"
							>
								<p class="caption mb-1 text--disabled font-weight-bold">
									<v-icon size="12" color="#2D4B95">mdi-reply</v-icon>
									{{ interaction.interactions.length }} respuesta(s) directa(s)
								</p>
								<div
									v-for="(sub, subIndex) in interaction.interactions"
									:key="subIndex"
									class="sub-interaction-item pa-2 mb-1"
								>
									<div class="d-flex align-center mb-1">
										<img
											v-if="resolveUser(sub.user).info.avatar"
											:src="resolveUser(sub.user).info.avatar"
											class="user-avatar small mr-1"
										/>
										<v-icon v-else size="16" color="#2D4B95">mdi-account-circle</v-icon>
										<span class="caption font-weight-bold text-primary ml-1">{{ resolveUser(sub.user).name }}</span>
										<span class="caption text--disabled ml-2">{{ sub.created_at | toDateTime }}</span>
									</div>
									<div v-html="sub.message || sub.description"></div>
								</div>
							</div>
            </div>

            <div class="attachments-section px-2">
              <div class="my-0" v-if="hasAttachments(interaction)">
                <div class="d-flex align-center mb-1">
                  <p class="mb-0 font-weight-bold caption">
                    {{ interaction.attachments.length }} Documentos Adjuntos:
                  </p>
                  <v-btn
                    v-if="interaction.attachments.length > 1"
                    class="mx-2 my-1"
                    rounded
                    color="#2D4B95"
                    dark
                    x-small
                    :loading="loadingFilePath"
                    @click="() => downloadAttachments(interaction)"
                  >
                    <v-icon dark small>mdi-paperclip</v-icon>
                    <p class="mb-0 ml-2">Descargar Todo</p>
                  </v-btn>
                </div>
                <div
                  v-for="(attachment, index) in interaction.attachments.filter(item => !item.pathmedia)"
                  :key="index"
                >
                  <div class="d-flex flex-row align-center px-1">
                    <p class="mb-0 text-primary mr-2" style="min-width: 60px">
                      <AttachmentPreviewButton
                        :attachment="attachment"
                        :loading="loadingFilePath"
                        compact
                        plain
                        @preview="previewAttachment"
                      />
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-1 my-1"
                            color="#2D4B95"
                            dark
                            x-small
                            icon
                            :loading="loadingFilePath"
                            v-bind="attrs"
                            v-on="on"
                            @click="getFilesUrl(attachment, true)"
                          >
                            <v-icon>mdi-open-in-new</v-icon>
                          </v-btn>
                        </template>
                        <span>Visualizar en navegador</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-1 my-1"
                            color="#5E85EF"
                            dark
                            x-small
                            icon
                            :loading="loadingFilePath"
                            v-bind="attrs"
                            v-on="on"
                            @click="getFilesUrl(attachment, true, true)"
                          >
                            <v-icon>mdi-cloud-download-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Descargar archivo</span>
                      </v-tooltip>
                    </p>
                    <p class="mb-0 caption">{{ attachment.name }}</p>
                  </div>
                  <v-divider
                    v-if="index < interaction.attachments.filter(item => !item.pathmedia).length - 1"
                  ></v-divider>
                </div>
                <div v-if="showMore">
                  <v-divider class="my-3"></v-divider>
                  <div class="bottom-file-container">
                    <div
                      class="d-flex flex-row"
                      :key="index"
                      v-for="(attachment, index) in interaction.attachments"
                    >
                      <v-btn
                        class="mx-2 my-1"
                        color="#5E85EF"
                        dark
                        small
                        text
                        :loading="loadingFilePath"
                        @click="getFilesUrl(attachment, true)"
                      >
                        <v-icon dark color="#2D4B95">mdi-file-document-outline</v-icon>
                        <p class="mb-0">{{ attachment.name }}</p>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
							<v-divider class="my-0 w-100" v-if="hasAttachments(interaction)"></v-divider>
              <div class="d-flex align-center justify-space-between w-100">
                <div class="text-center text-primary" style="font-size: 10px;">
                  <b>[{{ itemLabel }}]</b> - {{ interaction.created_at | toDateTime }}
                </div>
                <div class="d-flex flex-row align-center justify-end">
                  <p class="mb-0 text-primary" style="font-size: 10px;">Visto por:</p>
                  <div class="ml-1" v-if="!interaction.seen_by || interaction.seen_by.length === 0">
                    --
                  </div>
                  <SeenByUsers
                    v-model="seenByMenus[interaction.id]"
                    :seenByUsers="interaction.seen_by || []"
                  />
                </div>
              </div>
            </div>

						<v-divider class="my-1"></v-divider>

            <div class="reactions-bar px-2 pb-2" :class="{ 'reactions-bar--loading': loadingReaction }">
							<div class="reactions-list">
								<button
									v-for="(data, emoji) in interaction.reactions_grouped || []"
									:key="emoji"
									class="reaction-chip"
									:class="{ 'reaction-chip--mine': data.mine }"
									:disabled="loadingReaction === `${interaction.id}-${data.emoji}`"
									@click="toggleReaction(interaction.id, data.emoji)"
								>
									<v-progress-circular
										v-if="loadingReaction === `${interaction.id}-${data.emoji}`"
										indeterminate size="12" width="2" color="#2D4B95"
									/>
									<template v-else>
										{{ data.emoji }} <span class="reaction-count">{{ data.count }}</span>
									</template>
								</button>

                <div class="emoji-picker-wrapper">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <button
                        class="reaction-add-btn"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="togglePicker(interaction.id)"
                      >
                        <v-icon size="14" color="#2D4B95">mdi-emoticon-happy-outline</v-icon>
                        <v-icon size="10" color="#2D4B95">mdi-plus</v-icon>
                      </button>
                    </template>
                    <span>Agregar reacción</span>
                  </v-tooltip>

                  <div
                    class="emoji-picker"
                    v-if="activePickerId === interaction.id"
                    v-click-outside="closePicker"
                  >
										<button
											class="emoji-option"
											v-for="emoji in availableEmojis"
											:key="emoji"
											:disabled="loadingReaction && loadingReaction.startsWith(`${interaction.id}-`)"
											@click.stop="toggleReaction(interaction.id, emoji)"
										>
											{{ emoji }}
										</button>
                  </div>
                </div>
              </div>
              <v-btn
								v-if="canReplyToInteraction"
                text
                x-small
                color="#2D4B95"
                class="reply-btn"
                @click="replyToInteraction(interaction)"
              >
                <v-icon left size="13">mdi-reply</v-icon>
                Responder
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import systemLogo from '../../../assets/Svg/logoIconBlue.svg'
import { getPublicUrl } from '@/helpers/api/tasks'
import { getParentElement } from '@/helpers/api/general'
import { assocClickMixin } from '@/helpers/assocClickMixin'
import { markInteractionAsViewed } from '@/helpers/api/interactions'
import { addReactionToItem } from '@/helpers/api/interactions'
import { getZippedFiles } from '@/helpers/api/fileUploads'
import MediaGallery from '@/components/Globals/Helpers/MediaGallery'
import GlobalFileViewer from '@/components/Globals/Helpers/GlobalFileViewer'
import AttachmentPreviewButton from '@/components/Globals/Helpers/AttachmentPreviewButton'
import SeenByUsers from '@/components/Globals/Helpers/SeenByUsers'
import _debounce from 'lodash/debounce'

export default {
  name: 'Interaction',
  mixins: [assocClickMixin],
  components: { MediaGallery, GlobalFileViewer, AttachmentPreviewButton, SeenByUsers },
  props: {
    interactions: {
      type: Array,
      default: () => []
    },
    searchText: {
      type: String,
      default: ''
    },
    itemType: {
      type: String,
      default: 'tasks_restrictions_interactions',
      validator: (value) => [
        'tasks_restrictions_interactions',
        'rdi_interactions',
        'additional_interactions',
				'additional_general_interactions',
				'meetings_interactions'
      ].includes(value)
    },
    itemId: {
      type: [Number, String],
      default: null
    },
		item: {
			type: Object,
			required: true,
		},
    beforeNavigate: {
      type: Function,
      default: null
    }
  },
  data: () => ({
    loadingFilePath: false,
    showMore: false,
    activePickerId: null,
    availableEmojis: ['👍', '❤️', '😂', '😮', '😢', '👏', '🔥', '✅'],
		loadingReaction: null,
		pendingReactionKey: null,
    reactions: {},
		localInteractions: [],
		newlyViewedInteractions: [],
    seenByMenus: {},
    viewerDocumentItem: null,
    viewerForgeItem: null
  }),
  computed: {
		itemLabel(){
			const item_type = this.itemType === 'tasks_restrictions_interactions' ? 'Tarea' :
				this.itemType === 'rdi_interactions' ? 'RDI' :
				this.itemType === 'additional_interactions' ? 'Adicional' :
				this.itemType === 'additional_general_interactions' ? 'Adicional' :
				this.itemType === 'meetings_interactions' ? 'Reunión/Minuta' :
				'Item'
			return `${item_type} Nº${this.item.number}`
		},
		canReplyToInteraction() {
			return this.itemType !== 'rdi_interactions'
		},
    groupedInteractions () {
      if (!this.interactions || this.interactions.length === 0) return []
      const groups = []
      let currentGroup = []
      let currentUserId = null
      this.interactions.forEach((interaction) => {
        const userId = interaction.user ? interaction.user.id : 'system'
        if (userId !== currentUserId) {
          if (currentGroup.length > 0) groups.push(currentGroup)
          currentGroup = [interaction]
          currentUserId = userId
        } else {
          currentGroup.push(interaction)
        }
      })
      if (currentGroup.length > 0) groups.push(currentGroup)
      return groups
    }
  },
	watch: {
		interactions: {
			deep: true,
			handler () {
				if (this.pendingReactionKey) {
					this.loadingReaction = null
					this.pendingReactionKey = null
				}
			}
		}
	},
  mounted () {
    this.$nextTick(() => {
      this.initObserver()
      // Listener delegado para los spans .assoc-btn generados por el backend
      this.$_bindAssocClick(this.$el)
			// Scroll to last interaction
			if (this.interactions.length > 0) {
				const lastInteraction = this.interactions[this.interactions.length - 1]
				this.scrollToInteraction(lastInteraction.id, 4000)
			}
    })

		// Crear la función debounceada de 3 segundos
		this.debouncedMarkAsSeen = _debounce(this.markInteractionsAsSeen, 3000)
  },
  beforeDestroy () {
    if (this._observer) this._observer.disconnect()
		if (this.debouncedMarkAsSeen) {
			this.debouncedMarkAsSeen.cancel()
		}
		this.$_unbindAssocClick(this.$el)
  },
  methods: {
    initObserver () {
      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const id = entry.target.dataset.interactionId
              const interaction = this.interactions.find(i => String(i.id) === String(id))
              if (interaction) this.onInteractionVisible(interaction)
            }
          })
        },
        { threshold: 0.5 }
      )
      Object.keys(this.$refs).forEach((key) => {
        if (key.startsWith('interaction-')) {
          const els = this.$refs[key]
          const el = Array.isArray(els) ? els[0] : els
          if (el) this._observer.observe(el)
        }
      })
    },

    onInteractionVisible (interaction) {
			if (!this.newlyViewedInteractions.includes(interaction.id)) {
				const currentUserId = this.$store.userStore.state.userInfo.id
				const alreadySeen = interaction.seen_by && interaction.seen_by.some(
					seenItem => seenItem.user_id === currentUserId
				)
				
				if (!alreadySeen) {
					this.newlyViewedInteractions.push(interaction.id)
					this.debouncedMarkAsSeen()
				}
			}
    },

		async markInteractionsAsSeen () {
			if (this.newlyViewedInteractions.length === 0) {
				return
			}
			const idsToSend = [...this.newlyViewedInteractions]
			
			try {
				await markInteractionAsViewed({
					interaction_ids: idsToSend,
					interaction_type: this.itemType
				})
				this.$emit('reload')
				this.newlyViewedInteractions = []
			} catch (error) {
				console.error('Error marcando interacciones como visto:', error)
				// La siguiente interacción visible reintentará el envío
			}
		},
    replyToInteraction (interaction) {
      this.$emit('reply-interaction', interaction)
    },

    async beforeAssocNavigate () {
      if (this.beforeNavigate) {
        return this.beforeNavigate()
      }
      this.$emit('minimizeParent')
    },

    afterAssocNavigate (id, type) {
      this.$emit('assoc-click', { id, type })
    },

    scrollToInteraction (parentId, highlight_delay = 2000) {
      this.$nextTick(() => {
        const refKey = `interaction-${parentId}`
        const els = this.$refs[refKey]
        const el = Array.isArray(els) ? els[0] : els

        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          // Agregar un efecto visual de highlight temporal
          el.classList.add('highlight-interaction')
          setTimeout(() => {
            el.classList.remove('highlight-interaction')
          }, highlight_delay)
        }
      })
    },

    getReactions (interactionId) {
      return this.reactions[interactionId] || {}
    },

    togglePicker (interactionId) {
      this.activePickerId = this.activePickerId === interactionId ? null : interactionId
    },

    closePicker () {
      this.activePickerId = null
    },

    closeSeenByMenu (interactionId) {
      this.$set(this.seenByMenus, interactionId, false)
    },

    
		async toggleReaction (interactionId, emoji) {
			const key = `${interactionId}-${emoji}`
			if (this.loadingReaction === key) return

			this.loadingReaction = key
			this.pendingReactionKey = key
			this.activePickerId = null

			const safetyTimer = setTimeout(() => {
				this.loadingReaction = null
				this.pendingReactionKey = null
			}, 5000)

			try {
				const response = await addReactionToItem({
					item_id: this.itemId || interactionId,
					interaction_id: interactionId,
					item_type: this.itemType,
					reaction: emoji
				})
				if (response && response.code === 200) {
					this.$emit('reload')
					// el watch se encarga de limpiar cuando lleguen los datos nuevos
				} else {
					clearTimeout(safetyTimer)
					this.loadingReaction = null
					this.pendingReactionKey = null
					this.$toast?.error('No se pudo guardar la reacción. Intente de nuevo.')
				}
			} catch (error) {
				clearTimeout(safetyTimer)
				this.loadingReaction = null
				this.pendingReactionKey = null
				this.$toast?.error('No se pudo guardar la reacción. Intente de nuevo.')
			}
		},

    // ── Helpers existentes ───────────────────────────────────────────────────
    truncateHtml (html, maxLength = 150) {
      if (!html) return ''
      // Remover etiquetas HTML y decodificar entidades
      const div = document.createElement('div')
      div.innerHTML = html
      const text = div.textContent || div.innerText || ''
      const cleanText = text.trim()
      
      if (cleanText.length > maxLength) {
        return cleanText.substring(0, maxLength) + '...'
      }
      return cleanText
    },
    hasAttachments (interaction) {
      return interaction.attachments.filter(item => !item.pathmedia).length > 0
    },
    setClassInteraction (interaction) {
      let finalClass = this.isMyInteraction(interaction.user) ? 'right' : 'left'
      finalClass += interaction.is_response ? ' response' : ''
      return finalClass
    },
    isMyInteraction (interactionUser) {
      if (!interactionUser) return false
      return interactionUser.id == this.$store.userStore.state.userInfo.id
    },
    previewAttachment (attachment) {
      this.viewerDocumentItem = null
      this.viewerForgeItem = null

      if (attachment?.pathdoc?.path) {
        this.viewerDocumentItem = attachment
        return
      }

      if (attachment?.forge_file?.translated) {
        this.viewerForgeItem = attachment
        return
      }

      this.$store.globalStore.dispatch('addMessage', {
        message: 'Este archivo no tiene un visor disponible.',
        title: 'Vista previa no disponible',
        created: new Date(),
        type: 'warning',
        icon: 'mdi-eye-off-outline',
        color: '#FB8500'
      })
    },
    closeViewers () {
      this.viewerDocumentItem = null
      this.viewerForgeItem = null
    },
    minimizeViewerFile (item) {
      if (!item) return
      this.$store.globalStore.commit('addFileToFileManagerHandler', item)
      this.closeViewers()
    },
    async openAssociatedItem (item) {
      const typeMap = {
        'App\\Models\\TasksRestrictions': 'task',
        'App\\Models\\TasksRestrictionsInteractions': 'task_interaction'
      }

      if (!item || !typeMap[item.morphable_type] || !item.morphable_id) return

      this.minimizeViewerFile(item)
      this.$store.consultasStore.commit('setCurrentTarea', { loading: true })
      const element = await getParentElement({
        item_id: item.morphable_id,
        item_type: typeMap[item.morphable_type]
      })

      if (element.code === 200) {
        this.$store.consultasStore.commit('setCurrentTarea', element.task)
      }
    },
    onViewerError () {
      console.error('Attachment viewer failed to load')
    },
    onViewerLoad () {},
    resolveUser (user) {
      if (user) return user
      return {
        id: 'system',
        name: 'Sistema LaOT',
        info: { avatar: systemLogo },
        projectjob: null
      }
    },
    async downloadAttachments (interaction) {
      this.loadingFilePath = true
      const toZip = interaction.attachments.map(item => item.id)
      const fileName = `[${this.itemLabel}] - ${this.$options.filters.toDateTime(interaction.created_at)}`

      try {
        const files = await getZippedFiles({ file_ids: toZip, file_name: fileName })
        if (files.code == 200) window.open(files.fileurl)
      } finally {
        this.loadingFilePath = false
      }
    },
    async getFilesUrl (attachments, singleFile = false, download = false) {
      if (singleFile) attachments = [attachments]
      this.loadingFilePath = true
      const files = await getPublicUrl({ attachments, force_download: download })
      if (files.code === 200) files.files.forEach(file => window.open(file.url))
      this.loadingFilePath = false
    }
  }
}
</script>

<style scoped>
/* ── estilos existentes ────────────────────────────────────────────── */
.info-container { color: #606060; }
.text-primary { color: #2D4B95; }
.info-icon { background-color: #2D4B95; border-radius: 25px; padding: 3px; width: 35px; height: 35px; }
.info-icon.small-icon { width: 25px; height: 25px; }
.info-img { width: 100%; max-height: 50px; object-fit: contain; }
.adjuntos-container { background-color: #EFEFEF; max-height: 95px; overflow-y: scroll; }
.messages-group { display: flex; flex-direction: column; gap: 8px; height: 100%; }
.messages-group.single-message { height: 100%; }
.messages-group.single-message .interaction-container { height: 100%; }
.interaction-container { width: 100%; display: flex; flex-direction: column; background-color: #E5E9F2; border-radius: 5px; position: relative; padding: 0; }
.interaction-message-container { border-top-right-radius: 5px; border-top-left-radius: 5px; background-color: #fff; border: 1px solid #dbe5ff; flex: 1; }
.interaction-container.response .interaction-message-container { border: 1px solid #CAE7CC; }
.interaction-container.response { background-color: #CAE7CC; }
.inner-user-avatar { width: 40px; height: 40px; border-radius: 40px; object-fit: cover; }
.user-avatar.small { width: 25px; height: 25px; }
.light-blue-text { color: #5E85EF; }
.interaction-container .icon-arrow { font-size: 40px; position: absolute; top: 15px; line-height: inherit; }
.interaction-container.right .icon-arrow { left: -23px; }
.interaction-container.left .icon-arrow { right: -23px; }
.icon-top { padding: 2px; margin: 0 2px; border-radius: 100%; }
.icon-top.high { background-color: #F4516C; }
.icon-top.medium { background-color: #fb8c00; }
.icon-top.normal { background-color: #3EBFA3; }
.icon-top.primary { background-color: #2D4B95; }
.icon-top.light-blue, .bg-light-blue { background-color: #5E85EF; }
.parent-subtareas { display: flex; flex-wrap: wrap; }
.parent-subtareas .subtareas-checkbox { flex: 1 0 30%; }
.notification-img { width: 30px; height: 30px; border-radius: 100%; }
.preview-img-container { position: relative; }
.preview-img { width: 50px; height: 50px; border-radius: 10px; object-fit: contain; }
.button-preview-img { position: absolute; top: -1px; left: -1px; background-color: white; }
.user-container-info { background-color: #F5F5F5; border-radius: 5px; height: 100%; }
.w-100 { width: 100%; }
.attachments-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.item-label-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}
/deep/ .interaction-container p { margin-bottom: 4px; }
/deep/ .is_response_interaction .tiptap-vuetify-editor__content { border: 2px solid #3ebfa3; }
.is_response_interaction_bottom_text { color: #3ebfa3; }
/deep/ span.highlight { background-color: #8dfff4; }

/* ── Reacciones ────────────────────────────────────────────────────── */
.reactions-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px;
  min-height: 28px;
}
.reactions-bar--loading {
  opacity: 0.45;
  pointer-events: none;
}
.reactions-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.reaction-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  border-radius: 12px;
  background-color: rgba(255,255,255,0.7);
  border: 1px solid #dbe5ff;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, transform 0.1s;
  line-height: 1.4;
}
.reaction-chip:hover {
  background-color: #dbe5ff;
  transform: scale(1.08);
}
.reaction-chip--mine {
  background-color: #d0deff;
  border-color: #2D4B95;
}
.reaction-count {
  font-size: 11px;
  color: #2D4B95;
  font-weight: 600;
}
.reaction-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 5px;
  border-radius: 12px;
  background-color: rgba(255,255,255,0.6);
  border: 1px dashed #aab8d8;
  cursor: pointer;
  transition: background-color 0.15s;
  line-height: 1;
}
.reaction-add-btn:hover {
  background-color: #dbe5ff;
}
.emoji-picker-wrapper {
  position: relative;
}
.emoji-picker {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  z-index: 200;
  background: #fff;
  border: 1px solid #dbe5ff;
  border-radius: 12px;
  padding: 6px 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  width: 180px;
  box-shadow: 0 4px 16px rgba(45,75,149,0.15);
}
.emoji-option {
  font-size: 20px;
  cursor: pointer;
  padding: 3px;
  border-radius: 6px;
  transition: background-color 0.1s, transform 0.1s;
  background: none;
  border: none;
  line-height: 1;
}
.emoji-option:hover {
  background-color: #f0f4ff;
  transform: scale(1.2);
}
.reply-btn {
  font-size: 11px !important;
  letter-spacing: 0.2px;
  opacity: 0.75;
  transition: opacity 0.15s;
}
.reply-btn:hover {
  opacity: 1;
}
.sub-interactions {
  border-top: 1px dashed #dbe5ff;
  padding-top: 8px;
}
.sub-interaction-item {
  background-color: rgba(255,255,255,0.6);
  border-left: 3px solid #5E85EF;
  border-radius: 0 4px 4px 0;
  font-size: 13px;
}
.parent-interaction-reference {
  background-color: transparent;
  border-left: none;
  border-radius: 0;
  margin: 0;
  padding: 4px 0 8px 0;
  font-size: 11px;
}
.parent-avatar {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  object-fit: cover;
}
.parent-link-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: inherit;
  text-align: left;
  transition: opacity 0.2s ease;
}
.parent-link-btn:hover {
  opacity: 0.7;
  text-decoration: underline;
}
.parent-link-btn:active {
  opacity: 0.5;
}
.interaction-container.highlight-interaction {
	background-color: #fff9e6;
  animation: highlightPulse 3s ease-out;
}
@keyframes highlightPulse {
  0% {
    box-shadow: none;
  }
  10% {
    box-shadow: 0 0 0 2px #ffd700!important;
  }
  100% {
    box-shadow: none;
  }
}

/* Usuario Info Mobile */
.user-info-mobile {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.user-info-mobile.justify-start {
  justify-content: flex-start;
}
.user-info-mobile.justify-end {
  justify-content: flex-end;
}
.user-info-mobile-container {
  display: inline-flex;
  background-color: #F5F5F5;
  border-radius: 5px;
  width: auto;
}

@media (max-width: 599px) {
  .item-label-section {
    width: 100%;
  }
}
</style>
<style>
.user-mention {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	background-color: #e3f2fd;
	color: #1565c0;
	border-radius: 12px;
	padding: 2px 8px 2px 6px;
	font-size: 0.875em;
	font-weight: 500;
	cursor: default;
	user-select: none;
	white-space: nowrap;
	vertical-align: middle;
}
.user-mention:hover{
	background-color: #bbdefb;
}
.assoc-btn{
	display: inline-flex;
	align-items: center;
	gap: 4px;
	background-color: #f0f4ff;
	color: #2D4B95;
	border-radius: 12px;
	padding: 4px 12px;
	font-size: 0.875em;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.15s, transform 0.1s;
}

.assoc-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(93,133,239,0.14);
}

.assoc-btn::after {
  content: '';
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-left: 8px;
  vertical-align: middle;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><title>link-variant</title><path fill='%232D4B95' d='M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z' /></svg>");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
</style>